import { Typography } from "@mui/material";
import ActiveGoalsList from "./ActiveGoalsList";

const Goals = () => {

  return (
    <>
      <Typography variant="h6" fontWeight="medium" sx={{ p: "5px", mb: 2 }}>
        Active Goals
      </Typography>
      <ActiveGoalsList />
    </>
  );
};

export default Goals;
